"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToProps = void 0;
const react_redux_1 = require("react-redux");
const user_1 = require("selectors/user");
const index_1 = __importDefault(require("./index"));
const mapStateToProps = (state) => ({ hasTeams: (0, user_1.hasTeams)(state) });
exports.mapStateToProps = mapStateToProps;
exports.default = (0, react_redux_1.connect)(exports.mapStateToProps)(index_1.default);
